<template>
  <div>
    <div @click="visible = true">
      <slot />
    </div>

    <a-modal
      title="选择供应商"
      :visible="visible"
      @cancel="cancel"
      :footer="null"
      width="800px"
    >
      <a-input-search
        placeholder="请输入供应商名称搜索"
        enter-button
        @search="onSearch"
      ></a-input-search>

      <Padding />

      <div class="input-tip">
        <div class="right">
          <span @click="changeView">找不到供应商？</span>
        </div>
        <Padding />
      </div>

      <div v-if="inputView">
        <a-input-search
          placeholder="请输入新的供应商"
          key="save"
          @search="onSave"
        >
          <a-button type="primary" slot="enterButton"> 保存 </a-button>
        </a-input-search>
        <Padding size="large" />
      </div>

      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        :rowKey="(record) => record.id"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        :rowClassName="() => 'clickable'"
        :customRow="
          (record) => {
            return {
              on: {
                click: () => {
                  onTableRowClick(record);
                },
              },
            };
          }
        "
      >
        <a-table-column title="编码" data-index="suppCode" />
        <a-table-column title="名称" data-index="suppName" />
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { add } from "@/api/setting/supplier";
export default {
  data() {
    return {
      visible: false,
      inputView: false,
    };
  },

  computed: {
    ...mapState("supplierSelector", [
      "loading",
      "current",
      "pageSize",
      "list",
      "total",
    ]),
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.list.length === 0) {
          this.getList();
        }
      }
    },
  },

  methods: {
    ...mapMutations("supplierSelector", [
      "setCurrent",
      "setPageSize",
      "setSearchValue",
    ]),
    ...mapActions("supplierSelector", ["getList"]),

    onChange(pagination) {
      this.setCurrent(pagination.current);
      this.setPageSize(pagination.pageSize);
      this.getList();
    },

    onSearch(value) {
      this.setSearchValue(value.trim());
      this.setCurrent(1);
      this.getList();
    },

    onTableRowClick(record) {
      this.$emit("change", {
        supplierId: record.id,
        suppCode: record.suppCode,
        suppName: record.suppName,
      });
      this.visible = false;
    },

    changeView() {
      this.inputView = !this.inputView;
    },

    onSave(value) {
      add({ suppName: value.trim() }).then((res) => {
        this.$emit("change", {
          supplierId: res,
          suppCode: res?.suppCode || "",
          suppName: res?.suppName || value.trim(),
        });
        this.visible = false;
        this.inputView = false;
      });
    },

    cancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.input-tip {
  font-size: 12px;
  cursor: pointer;
  color: #1890ff;
}
</style>
